import Text from "./Text";
import Image from "./Image";
import Line from "./Line";

const ComponentsMap = {
  text: Text,
  image: Image,
  line: Line,
};

export { ComponentsMap, Text, Image, Line };
